import loadAsync from "routing/loadAsync";
const Overview = loadAsync(() => import("./Overview"));
const UserActivity = loadAsync(() => import("./UserActivity"));
const HostActivity = loadAsync(() => import("./HostActivity"));
const NetworkActivity = loadAsync(() => import("./NetworkActivity"));
const Anomalies = loadAsync(() => import("./Anomalies"));
export { Overview, UserActivity, HostActivity, NetworkActivity, Anomalies };
